{
  "name": "reconcept-platform",
  "version": "6.2.17",
  "private": true,
  "license": "UNLICENSED",
  "browser": {
    "crypto": false
  },
  "scripts": {
    "ng": "ng",
    "nx": "nx",
    "start": "nx serve",
    "build": "npm run load-graphql-schema && nx build",
    "test": "nx test",
    "lint": "nx run-many --all --target=lint",
    "lint:many": "nx run-many --target=lint --projects=login,login-features,portfolio,portfolio-data-access,portfolio-featured,portfolio-shared,portfolio-support-shared,portfolio-universal-app,portfolio-universal-app-features,shared-authentication,shared-ui-core,storybook,support,workspace",
    "e2e": "nx e2e",
    "affected:apps": "nx affected:apps",
    "affected:libs": "nx affected:libs",
    "affected:build": "nx affected:build",
    "affected:e2e": "nx affected:e2e",
    "affected:test": "nx affected:test",
    "affected:lint": "nx affected:lint",
    "affected:dep-graph": "nx affected:dep-graph",
    "affected": "nx affected",
    "format": "nx format:write",
    "format:write": "nx format:write",
    "format:check": "nx format:check",
    "dep-graph": "nx dep-graph",
    "help": "nx help",
    "deploy": "build-scripts/deploy",
    "deploy:bunny": "npx ts-node build-scripts/deploy-bunny.ts",
    "deploy-nascholingsagenda": "build-scripts/deploy-nascholingsagenda",
    "deploy-formulariumapp": "build-scripts/deploy-formulariumapp",
    "deploy-kwaliteit": "build-scripts/deploy-kwaliteit",
    "storybook": "NG_BUILD_MAX_WORKERS=4 nx run storybook:storybook",
    "workspace-generator": "nx workspace-generator",
    "create-release": "build-scripts/create-release",
    "append-i18n": "build-scripts/append-i18n",
    "generate": "graphql-codegen && npm run generated:more-types && npm run generated:cleanup && npm run format",
    "postgenerate": "node build-scripts/isnotnull-audit.mjs",
    "generated:more-types": "build-scripts/generate-more-based-on-graphql",
    "generated:format": "npm run format -- --files libs/shared/data-access/src/lib/utils/type-helpers-ids.generated.ts,libs/shared/types/generated.ts,libs/shared/types/schema-types.ts",
    "generated:cleanup": "perl -i -0pe \"s/\\s*\\|\\s*\\{\\s*\\n\\s*__typename:\\s*'[^']+'[;,\\s*]?\\n(?:\\s*id:\\s*string;\\n)?\\s*\\}//g\" \"libs/shared/types/generated.ts\"",
    "schema:check": "npx @graphql-inspector/cli validate --apollo 'libs/**/*.ts' libs/shared/data-access/src/lib/schema/schema.graphql",
    "tsc:check": "find . | grep -v node_modules | grep -E 'tsconfig.(lib|app).json' | perl -pe 's#/[^/]*$#\\n#'  | xargs npx tsc -b"
  },
  "dependencies": {
    "@angular/cdk": "22.2.1",
    "@angular/common": "22.2.1",
    "@angular/compiler": "22.2.1",
    "@angular/core": "22.2.1",
    "@angular/forms": "22.2.1",
    "@angular/localize": "22.2.1",
    "@angular/platform-browser": "22.2.1",
    "@angular/platform-browser-dynamic": "22.2.1",
    "@angular/platform-server": "22.2.1",
    "@angular/router": "22.2.1",
    "@angular/ssr": "22.2.1",
    "@apollo/client": "4.3.5",
    "@bugsnag/js": "8.10.0",
    "@bugsnag/plugin-angular": "8.10.0",
    "@capacitor-community/in-app-review": "8.0.0",
    "@capacitor-community/keep-awake": "8.0.1",
    "@capacitor/android": "8.5.3",
    "@capacitor/app": "8.1.2",
    "@capacitor/browser": "8.0.5",
    "@capacitor/core": "8.5.3",
    "@capacitor/device": "8.0.3",
    "@capacitor/filesystem": "8.1.5",
    "@capacitor/haptics": "8.0.2",
    "@capacitor/ios": "8.5.3",
    "@capacitor/keyboard": "8.0.6",
    "@capacitor/preferences": "8.0.1",
    "@capacitor/share": "8.0.3",
    "@capacitor/splash-screen": "8.0.2",
    "@capawesome/capacitor-app-update": "8.1.1",
    "@capawesome/capacitor-badge": "8.0.4",
    "@capgo/capacitor-native-biometric": "8.9.1",
    "@floating-ui/dom": "1.8.0",
    "@fortawesome/angular-fontawesome": "5.1.0",
    "@fortawesome/fontawesome-common-types": "7.3.1",
    "@fortawesome/fontawesome-svg-core": "7.3.1",
    "@fortawesome/free-brands-svg-icons": "7.3.1",
    "@fortawesome/pro-duotone-svg-icons": "7.3.1",
    "@fortawesome/pro-regular-svg-icons": "7.3.1",
    "@fortawesome/pro-solid-svg-icons": "7.3.1",
    "@googlemaps/js-api-loader": "2.1.3",
    "@ionic/angular": "8.8.19",
    "@ionic/core": "8.8.19",
    "@meddv/ngx-pinch-zoom": "20.0.0",
    "@ngx-translate/core": "18.0.0",
    "@ngx-translate/http-loader": "18.0.0",
    "@rails/actioncable": "8.1.400",
    "@tiptap/core": "3.32.0",
    "@tiptap/extension-blockquote": "3.32.0",
    "@tiptap/extension-bold": "3.32.0",
    "@tiptap/extension-bubble-menu": "3.32.0",
    "@tiptap/extension-bullet-list": "3.32.0",
    "@tiptap/extension-document": "3.32.0",
    "@tiptap/extension-floating-menu": "3.32.0",
    "@tiptap/extension-gapcursor": "3.32.0",
    "@tiptap/extension-heading": "3.32.0",
    "@tiptap/extension-history": "3.32.0",
    "@tiptap/extension-image": "3.32.0",
    "@tiptap/extension-italic": "3.32.0",
    "@tiptap/extension-link": "3.32.0",
    "@tiptap/extension-list-item": "3.32.0",
    "@tiptap/extension-mention": "3.32.0",
    "@tiptap/extension-ordered-list": "3.32.0",
    "@tiptap/extension-paragraph": "3.32.0",
    "@tiptap/extension-placeholder": "3.32.0",
    "@tiptap/extension-strike": "3.32.0",
    "@tiptap/extension-superscript": "3.32.0",
    "@tiptap/extension-table": "3.32.0",
    "@tiptap/extension-table-cell": "3.32.0",
    "@tiptap/extension-table-header": "3.32.0",
    "@tiptap/extension-table-row": "3.32.0",
    "@tiptap/extension-text": "3.32.0",
    "@tiptap/extension-underline": "3.32.0",
    "@tiptap/pm": "3.32.0",
    "@tiptap/starter-kit": "3.32.0",
    "@tiptap/static-renderer": "3.32.0",
    "@tiptap/suggestion": "3.32.0",
    "apollo-angular": "14.2.0",
    "capacitor-voice-recorder": "7.0.6",
    "chart.js": "4.6.1",
    "chartjs-adapter-date-fns": "3.0.0",
    "chartjs-plugin-datalabels": "2.2.0",
    "core-js": "3.50.0",
    "crisp-sdk-web": "1.2.1",
    "d3-array": "3.2.4",
    "d3-axis": "3.0.0",
    "d3-ease": "3.0.1",
    "d3-interpolate": "3.0.1",
    "d3-request": "1.0.6",
    "d3-scale": "4.0.2",
    "d3-selection": "3.0.0",
    "d3-shape": "3.2.0",
    "d3-transition": "3.0.1",
    "date-fns": "4.4.0",
    "express": "4.22.3",
    "graphql": "16.14.2",
    "lodash-es": "4.18.1",
    "qrcode": "1.5.4",
    "rxjs": "7.8.2",
    "spark-md5": "3.0.2",
    "web-animations-js": "2.3.2",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.18.9/xlsx-0.18.9.tgz",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "2.7.3",
    "@analogjs/vitest-angular": "2.7.3",
    "@angular-devkit/build-angular": "22.2.1",
    "@angular-devkit/core": "22.2.1",
    "@angular-devkit/schematics": "22.2.1",
    "@angular/build": "22.2.1",
    "@angular/cli": "22.2.1",
    "@angular/compiler-cli": "22.2.1",
    "@angular/language-service": "22.2.1",
    "@bugsnag/core": "8.9.0",
    "@bugsnag/source-maps": "2.3.3",
    "@bunny.net/storage-sdk": "0.3.2",
    "@eslint/eslintrc": "3.3.7",
    "@eslint/js": "10.0.1",
    "@graphql-codegen/cli": "7.4.6",
    "@graphql-codegen/typescript": "6.1.2",
    "@graphql-codegen/typescript-operations": "6.2.0",
    "@graphql-eslint/eslint-plugin": "4.4.2",
    "@graphql-inspector/cli": "7.0.2",
    "@ionic/angular-toolkit": "12.3.0",
    "@nx/devkit": "24.0.1",
    "@nx/eslint": "24.0.1",
    "@nx/eslint-plugin": "24.0.1",
    "@nx/js": "24.0.1",
    "@nx/playwright": "24.0.1",
    "@nx/storybook": "24.0.1",
    "@nx/vite": "24.0.1",
    "@nx/web": "24.0.1",
    "@nx/workspace": "24.0.1",
    "@oxc-project/runtime": "0.148.0",
    "@playwright/test": "1.62.1",
    "@schematics/angular": "22.2.1",
    "@storybook/addon-docs": "10.6.0",
    "@storybook/angular": "10.6.3",
    "@swc-node/register": "1.12.1",
    "@swc/core": "1.16.1",
    "@swc/helpers": "0.5.23",
    "@types/cordova": "11.0.3",
    "@types/d3": "7.4.3",
    "@types/d3-array": "3.2.2",
    "@types/d3-axis": "3.0.6",
    "@types/d3-ease": "3.0.2",
    "@types/d3-interpolate": "3.0.4",
    "@types/d3-request": "1.0.9",
    "@types/d3-scale": "4.0.9",
    "@types/d3-selection": "3.0.12",
    "@types/d3-shape": "3.2.0",
    "@types/d3-transition": "3.0.9",
    "@types/express": "4.17.21",
    "@types/lodash-es": "4.17.12",
    "@types/node": "26.6.5",
    "@types/qrcode": "1.5.6",
    "@types/rails__actioncable": "8.0.3",
    "@types/spark-md5": "3.0.5",
    "@typescript-eslint/parser": "8.69.0",
    "@vitest/coverage-v8": "4.1.11",
    "@vitest/ui": "4.1.11",
    "angular-eslint": "22.5.0",
    "eslint": "10.9.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-import-resolver-typescript": "4.4.5",
    "eslint-plugin-boundaries": "7.3.0",
    "eslint-plugin-playwright": "2.11.0",
    "eslint-plugin-storybook": "10.6.0",
    "jiti": "2.7.0",
    "jsdom": "27.3.0",
    "ngxtension": "5.1.0",
    "nx": "24.0.1",
    "onesignal-cordova-plugin": "5.6.1",
    "prettier": "3.9.6",
    "prettier-plugin-organize-imports": "4.3.0",
    "prosemirror-commands": "1.7.2",
    "prosemirror-dropcursor": "1.8.4",
    "prosemirror-gapcursor": "1.4.1",
    "prosemirror-history": "1.5.1",
    "prosemirror-keymap": "1.2.3",
    "prosemirror-model": "1.25.12",
    "prosemirror-schema-list": "1.5.1",
    "prosemirror-state": "1.4.4",
    "prosemirror-transform": "1.12.4",
    "prosemirror-view": "1.42.8",
    "storybook": "10.6.3",
    "ts-node": "10.9.2",
    "tslib": "2.8.1",
    "typescript": "6.0.3",
    "typescript-eslint": "8.69.0",
    "vite": "8.2.4",
    "vitest": "4.1.11"
  }
}
